/* eslint-disable dot-notation */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import AWS from 'aws-sdk';
import GridLayout from 'react-grid-layout';
import { toast } from 'react-toastify';
import SectionHeader from '../../components/sectionHeader';
import Dashboard from '../../icons/airfield-icons/Dashboard.png';
import AirportInformation from './components/airport-information/AirportInformation';
import RunwayCondition from './components/runway-condition/RunwayCondition';
import Weather from './components/weather/Weather';
import Notams from './components/notams/Notams';
import Forms from './components/forms/Forms';
import Map from './components/map/Map';
// import Comments from './components/comments/Comments';
import Loading from '../../components/loading';
import UsefulLinks from './components/useful-links/UsefulLinks';
import styles from './airfields.module.scss';
import { fetchAirportInfo, fetchRunwayInfo, fetchUsefulLinks } from './components/redux/actions';
import { isLocal, hostName } from '../../constants/apiEnv';
import { getS3Region } from '../../utils/helpers';
import CustomPrint from './CustomPrint';

const AirfieldsConditions = ({
  actionSaveAirportInfo,
  actionSaveRunwayInfo,
  actionSaveUsefulLinks,
  airportInfo,
  runwayInfo,
  usefulLinksInfo,
  user
}) => {
  const [checkEU, setCheckEU] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formLoading, setformLoading] = useState(false);
  const [isPoolAuthenticated, setIsPoolAuthenticated] = useState(false);
  const [fullScreenMode, setFullscreenMode] = useState(false);
  const [allAirportInfo, setAllAirportInfo] = useState('');
  const [visibility, setVisibility] = useState([]);
  const urlParams = useParams();
  const getTiles = async () => {
    try {
      setformLoading(true);
      const url = hostName.slice(6);
      const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://api.${urlParams?.id || 'us'}${url}/api/public`;

      await fetch(`${publicUrl}/operations/acr/${urlParams.airportCode.toUpperCase()}`)
        .then(response => response.json())
        .then((data) => {
          let visibilityStatus = {};
          data.forEach((i) => {
            visibilityStatus[i.tile_name] = i?.meta_data?.visibility;
          });
          setformLoading(false);
          setVisibility(visibilityStatus);
        });
    } catch (error) {
      setformLoading(false);
      setVisibility({});
    }
  };
  const getRunways = async () => {
    try {
      const url = hostName.slice(6);
      const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${urlParams?.id || 'us'}${url}/public`;

      setformLoading(true);
      await fetch(`${publicUrl}/airfield/data/${urlParams.airportCode.toUpperCase()}`)
        .then(response => response.json())
        .then((data) => {
          getTiles();
          setformLoading(false);
          setAllAirportInfo(data);
          actionSaveRunwayInfo(data?.runways, data?.airfield_condition_reporting);
          localStorage.setItem('dateFormat', data.airport_settings?.date_format || 'MM/DD/YYYY');
          localStorage.setItem('timeFormat', data.airport_settings?.time_format === '24' ? 'HH:mm' : 'hh:mm A');
        });
    } catch (error) {
      toast.error('Something went wrong');
    }
  };


  const getData = async (fileName, code) => {
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : code}-attachments/conditions`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      actionSaveAirportInfo(info);
    });

    await getRunways();
  };

  const getConfig = () => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION
    });
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  };

  useEffect(() => {
    const authenticate = getConfig();
    authenticate.then(() => {
      setIsPoolAuthenticated(true);
    }).catch(() => {
      setIsPoolAuthenticated(false);
    });
  }, []);


  useEffect(() => {
    if (!airportInfo) {
      try {
        setLoading(true);
        const docClient = new AWS.DynamoDB.DocumentClient();
        const params = {
          TableName: `${process.env.REACT_APP_PREFIX}airport_info`,
          Key: { id: `${urlParams.airportCode.toUpperCase()}_${urlParams?.id || 'us'}` }
        };
        docClient.get(params).promise().then((data) => {
          if (data?.Item) {
            if (data?.Item?.airportInformation) {
              if (data?.Item?.airportInformation?.attachment_name) {
                getData(data?.Item?.airportInformation?.attachment_name, urlParams?.id || 'us');
              } else {
                actionSaveAirportInfo(data?.Item?.airportInformation?.airport_information);
              }
            }
            actionSaveUsefulLinks(data.Item.usefulLinks);
            setLoading(false);
          } else if (checkEU === true) {
            setLoading(false);
          } else if (checkEU === false) {
            setCheckEU(true);
          }
        });
      } catch (error) {
        setLoading(false);
      }
    }
  }, [urlParams.airportCode, checkEU]);

  const tileOrder=useSelector(state => state.airfields.tileOrder);
  const layout = useMemo(
    () => tileOrder || [
      { i: 'a', x: 0, y: 0, w: 8, h: 4.3 },
      { i: 'b', x: 0, y: 3, w: 8, h: 3.5 },
      { i: 'c', x: 8, y: 0, w: 4, h: 8 },
      { i: 'd', x: 0, y: 7, w: 12, h: 3.2 },
      { i: 'e', x: 0, y: 7.2, w: 4, h: 4.5 },
      { i: 'f', x: 0, y: 8, w: 4, h: 4.5 },
      { i: 'k', x: 0, y: 8, w: 4, h: 4.5 }
        ],
    [tileOrder]
  );

  useEffect(() => {
      getRunways();
  }, []);

  const handelFullScreen = (state, id) => {
    const element = document.getElementById(id);
    if (state) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
        setFullscreenMode(true);
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
        setFullscreenMode(true);
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
        setFullscreenMode(true);
      }
    } else {
      document.exitFullscreen();
      setFullscreenMode(false);
    }
  };

  function exitHandler() {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      setFullscreenMode(false);
    }
  }

  document.addEventListener('fullscreenchange', exitHandler);
  document.addEventListener('webkitfullscreenchange', exitHandler);
  document.addEventListener('mozfullscreenchange', exitHandler);
  document.addEventListener('MSFullscreenChange', exitHandler);
  return (
    <Fragment>
      {isPoolAuthenticated && layout?.length > 0
        && (
        <Fragment>
          {loading && <Loading loadingStatus={loading && formLoading} />}
          <div className={styles.sectionheader}>
            <SectionHeader icon={Dashboard} translationID="shortcuts.airfieldconditons" defaultTitle="Airfield Conditions" />
          </div>
          <div className={`container ${styles.container}`}>
            <GridLayout
              isDraggable={false}
              layout={layout}
              cols={12}
              rowHeight={90}
              width={1500}
              isResizable={false}
              className={styles.customGrid}
              useCSSTransforms
            >
              {visibility?.['Airport Information'] && (
              <div key="a" id="1" data-grid={layout.find(i => i?.i === 'a') || { x: 0, y: 0, w: 8, h: 4.3 }}>
                <AirportInformation height data={airportInfo} handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                />
              </div>
              )}
              {visibility?.['Weather Conditions'] && (
              <div key="c" id="2" data-grid={layout.find(i => i?.i === 'c') || { x: 8, y: 0, w: 4, h: 8 }}>
                <Weather handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                  Metrics={allAirportInfo?.airport_settings?.metrics || {}}
                />
              </div>
              )}
              {visibility?.['Runway Conditions'] && (
               <div key="b" id="3" data-grid={layout.find(i => i?.i === 'b') || { x: 0, y: 3, w: 8, h: 3.5 }}>
                <RunwayCondition
                  margin
                  data={runwayInfo?.filter(item => item?.airfield_condition === true || item?.airfield_condition === undefined)}
                  handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                  airfieldCondition={allAirportInfo?.airport_additional_configuration?.airfield_condition}
                />
               </div>
              )}
              {visibility?.['NOTAMs'] && (
              <div key="d" id="4" data-grid={layout.find(i => i?.i === 'd') || { x: 0, y: 7, w: 12, h: 3.2 }}>
                <Notams margin
                  handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                />
              </div>
              )}
              {visibility?.['Useful liks'] && (
              <div key="e" id="5" data-grid={layout.find(i => i?.i === 'e') || { x: 0, y: 7.2, w: 4, h: 4.5 }}>
                <UsefulLinks data={usefulLinksInfo}
                  handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                />
              </div>
              )}
             {(allAirportInfo?.form_tile?.template_type === undefined || allAirportInfo?.form_tile?.template_type === 'default_print') && visibility?.['Forms']
            &&<div key="f" id="6" data-grid={layout.find(i => i?.i === 'f') || { x: 0, y: 8, w: 4, h: 4.5 }} className="drag-handle">
                <Forms
                  formDetails={allAirportInfo?.form_details || {}}
                  tileName={allAirportInfo?.form_tile?.tileName ||''}
                  location={allAirportInfo?.location}
                  mapStyle={allAirportInfo?.airport_additional_configuration}
                  enableForm={allAirportInfo?.form_tile?.enableform || false}
                  handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                />
              </div>}

              {allAirportInfo?.form_tile?.template_type === 'custom_print' && visibility?.['Forms']
             && <div key="f" className="drag-handle" id="6" style={{ overflowY: 'scroll', background: '#fff', border: '1px solid rgba(0,0,0,.125' }} data-grid={layout.find(i => i?.i === 'f') || { x: 0, y: 8, w: 4, h: 4.5 }}>
                <CustomPrint
                  tileName={allAirportInfo?.form_tile?.tileName ||''}
                  allAirportInfo={allAirportInfo}
                />
                </div>}
                {allAirportInfo?.location?.length>0 && allAirportInfo?.enable_map === true && visibility?.['Map'] && (
                  <div key="k" className="drag-handle" id="7" data-grid={layout.find(i => i?.i === 'k') || { x: 0, y: 8, w: 4, h: 4.5 }}>
                  <Map map_surfaces={allAirportInfo?.map_surfaces || []}
                  location={allAirportInfo&&allAirportInfo?.location} mapStyle={allAirportInfo?.airport_additional_configuration}
                  enableMap={allAirportInfo?.enable_map || false}
                  handelFullScreen={handelFullScreen}
                  fullScreenMode={fullScreenMode}
                />
                  </div>
               )}
            </GridLayout>
          </div>
        </Fragment>
        )}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  airportInfo: state.airfields.airportInfo,
  runwayInfo: state.airfields.runwayInfo,
  usefulLinksInfo: state.airfields.usefulLinks
});


const mapDispatchToProps = dispatch => ({
  actionSaveAirportInfo: (data) => {
    dispatch(fetchAirportInfo(data));
  },
  actionSaveRunwayInfo: (data, tileOrder) => {
    dispatch(fetchRunwayInfo(data, tileOrder));
  },
  actionSaveUsefulLinks: (data) => {
    dispatch(fetchUsefulLinks(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AirfieldsConditions);
